import { ifSelectorExist, getElements } from './utils';

export const attorneysTabs = () => {
  getElements('.attorneys-tabs-block').forEach(container => {
    const desktopTabs = container.querySelectorAll(
        '.attorneys-tabs-block__tabs_wrapper_desktop .attorneys-tabs-block__tab_item'
      ),
      mobileTabs = container.querySelectorAll(
        '.attorneys-tabs-block__tabs_wrapper_mobile .attorneys-tabs-block__tab_item'
      ),
      tabsContent = container.querySelectorAll(
        '.attorneys-tabs-block__content_item'
      );

    if (ifSelectorExist(desktopTabs) && ifSelectorExist(tabsContent)) {
      const toggleTabs = (index = 0) => {
        tabsContent.forEach((content, i) => {
          const isActive = i === index;
          content.classList.toggle('hidden', !isActive);
          content.classList.toggle('fade-out', !isActive);
          content.classList.toggle('block', isActive);
          content.classList.toggle('fade-in', isActive);
          desktopTabs[i].classList.toggle('active', isActive);
        });
      };

      desktopTabs.forEach((tab, i) =>
        tab.addEventListener('click', () => toggleTabs(i))
      );

      toggleTabs();
    }

    if (ifSelectorExist(mobileTabs) && ifSelectorExist(tabsContent)) {
      const toggleMobileTabs = (index = 0) => {
        tabsContent.forEach((content, i) => {
          const isActive = i === index;
          content.classList.toggle('hidden', !isActive);
          content.classList.toggle('fade-out', !isActive);
          content.classList.toggle('block', isActive);
          content.classList.toggle('fade-in', isActive);
          mobileTabs[i].classList.toggle('active', isActive);
        });
      };

      mobileTabs.forEach((tab, i) =>
        tab.addEventListener('click', () => toggleMobileTabs(i))
      );

      toggleMobileTabs();
    }
  });
};
